import Label, { type LabelProps } from '../../Form/Label';
import { useId, useMemo } from 'react';
import ReactDatePicker, { type DatePickerProps as ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fixDateForTimezone } from '@repo/util/fixDateForTimezone';
import { isValid } from 'date-fns';

export type DatePickerProps = Pick<LabelProps, 'hideLabel' | 'description'> &
  ReactDatePickerProps & {
    label?: string;
  };

export const DatePicker = ({
  id,
  label,
  hideLabel,
  date,
  startDate,
  endDate,
  selected,
  description,
  ...props
}: DatePickerProps) => {
  const defaultId = useId();
  id = id ?? defaultId;

  date = useMemo(() => {
    if (!date || !isValid(date)) {
      return;
    } else return fixDateForTimezone(date);
  }, [date]);
  startDate = useMemo(() => {
    if (!startDate || !isValid(startDate)) {
      return;
    } else return fixDateForTimezone(startDate);
  }, [startDate]);

  endDate = useMemo(() => {
    if (!endDate || !isValid(endDate)) {
      return;
    } else return fixDateForTimezone(endDate);
  }, [endDate]);

  selected = useMemo(() => {
    if (!selected) {
      return;
    }
    const newSelected = new Date(selected);
    return fixDateForTimezone(newSelected);
  }, [selected]);

  return (
    <div id={id} className="relative flex flex-col w-full gap-2">
      {label ? (
        <Label htmlFor={`${id}::input`} hideLabel={hideLabel} description={description}>
          {label}
        </Label>
      ) : null}
      <div className="relative w-full">
        <ReactDatePicker
          id={`${id}::input`}
          dateFormat="yyyy/MM/dd"
          date={date}
          startDate={startDate}
          endDate={endDate}
          selected={selected}
          {...props}
          className="w-full"
        />
      </div>
    </div>
  );
};
